import { Label } from 'component-library';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

type LocationStatusProps = {
  isActive: boolean;
};
export const LocationsStatus = ({ isActive }: LocationStatusProps) => {
  const { t } = useTranslation();
  const statusText = isActive ? t('user.details.status.active') : t('user.details.status.inactive');
  const labelVariant = isActive ? 'success' : undefined;

  return (
    <StyledLabelWrapper>
      <Label slim={true} variant={labelVariant}>
        {statusText}
      </Label>
    </StyledLabelWrapper>
  );
};

const StyledLabelWrapper = styled.div`
  align-self: center;
  display: inline-flex;
`;
